// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"15827573","899":"cb21aaca"}[chunkId] + ".chunk.js";
};